import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  ACTIVE,
  ARCHIVED,
} from '../../../../../presenters/TransactionPresenter';

const TabsSwitch = (props) => {
  const { currentState, onStateChange } = props;

  const tabButtonClassName = (tab) => {
    return cn('nav-button right-padding', { active: isActive(tab) });
  };

  const isActive = (tab) => tab === currentState;

  const changeStateToActive = () => onStateChange(ACTIVE);
  const changeStateToArchived = () => onStateChange(ARCHIVED);

  return (
    <div className="tabs">
      <button
        className={tabButtonClassName(ACTIVE)}
        onClick={changeStateToActive}
      >
        Active
      </button>
      <button
        className={tabButtonClassName(ARCHIVED)}
        onClick={changeStateToArchived}
      >
        Archived
      </button>
    </div>
  );
};

export default TabsSwitch;

TabsSwitch.propTypes = {
  currentState: PropTypes.string.isRequired,
  onStateChange: PropTypes.func.isRequired,
};
